import { Loading } from 'common/widgets'

/**
 * WithDataBlocker - HOC to ensure thirdParty data is fully loaded before rendering component
 *
 * CONTEXT: React 18 concurrency changes broke the internal blocking mechanism in
 * @ds-frontend/resource's prefetchResources HOC. Components that depend on thirdParty
 * data were rendering before the data was available, causing:
 * - Empty/missing data in render logic
 * - Flash of missing content (FOUC)
 * - Inconsistent UI states
 * - Form initialization with wrong data
 *
 * SOLUTION: This wrapper explicitly checks thirdParty loading state and data availability
 * before allowing the wrapped component to render, ensuring proper timing coordination.
 */
const WithDataBlocker = (WrappedComponent) => {
  const DataBlockerHOC = (props) => {
    // Block rendering if thirdParty data is still loading or not yet available
    // eslint-disable-next-line react/prop-types
    if(!props.thirdParty || props.thirdParty.isLoading || !props.thirdParty.data) {
      return <Loading isLoading />
    }
    // Data is ready, render the component
    return <WrappedComponent {...props} />
  }

  DataBlockerHOC.displayName = `WithDataBlocker(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`

  return DataBlockerHOC
}

export default WithDataBlocker
